import { createAsyncThunk } from '@reduxjs/toolkit';
import api from '@/api/apiSingleton';

export const sendAnalyticsEvent = createAsyncThunk(
  'events/sendAnalyticsEvent',
  async (payload: { eventName: string }) => {
    await api.events.sendAnalyticsEvent(payload);
  },
);
